import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { API } from './api';

const user = JSON.parse(localStorage.getItem('user'));

export const daynamicApi = createApi({
    reducerPath: 'daynamicApi',
    baseQuery: fetchBaseQuery({ baseUrl: `${API}` }),
    tagTypes: ['dynamic'],
    endpoints: (builder) => ({
        createFuction: builder.mutation({
            query: ({ formData, url }) => {
                return {
                    url: `${url}`,
                    method: 'POST',
                    body: formData,
                    headers: {
                        Authorization: `Bearer ${user?.token}`,
                    },
                    // contentType: "application/json"
                };
            },
            invalidatesTags: ['dynamic'],
        }),

        updateFunction: builder.mutation({
            query({ formData, id, url }) {
                return {
                    url: `${url}/${id}`,
                    method: 'PUT',
                    body: formData,
                    headers: {
                        Authorization: `Bearer ${user?.token}`,
                    },
                };
            },

            invalidatesTags: ['dynamic'],
        }),

        getByIdFunction: builder.query({
            query: ({ id, url }) => {
                return {
                    url: `${url}/${id}`,
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${user?.token}`,
                    },
                };
            },
            providesTags: ['dynamic', 'invoices'],
        }),

        getallFunction: builder.query({
            query({ url }) {
                return {
                    url: `${url}`,
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${user?.token}`,
                    },
                };
            },
            providesTags: (result) => (result ? [...result.map(({ id }) => [{ type: 'dynamic', id }]).flat(), { type: 'dynamic', id: 'LIST' }] : [{ type: 'dynamic', id: 'LIST' }]),
        }),
        getallFunctionByOwner: builder.query({
            query({ url, id }) {
                return {
                    url: `${url}/${id}`,
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${user?.token}`,
                    },
                };
            },
            providesTags: (result) => (result ? [...result.map(({ id }) => [{ type: 'dynamic', id }]).flat(), { type: 'dynamic', id: 'LIST' }] : [{ type: 'dynamic', id: 'LIST' }]),
        }),
    }),
});

export const { useCreateFuctionMutation, useUpdateFunctionMutation, useGetByIdFunctionQuery, useGetallFunctionQuery, useGetallFunctionByOwnerQuery } = daynamicApi;
